import { code } from "@spscommerce/utils";

export const SpsMicroBlocksExamples = {
    infoBlock: {
        label: "Info Micro Block",
        examples: {
            infoBlock: {
                template: code`
                   <sps-micro-block kind="info" message="Hey, here's something neat.">
            </sps-micro-block>              `
            }
        }
    },
    successBlock: {
        label: "Success Micro Block",
        examples: {
            successBlock: {
                template: code`
                <sps-micro-block kind="success" message="That was amazing!">
                </sps-micro-block>
                `
            }
        }
    },
    tipBlock: {
        label: "Tip Micro Block",
        examples: {
            tipBlock: {
                template: code`
                <sps-micro-block kind="tip" message="Pro Tip: Always be yourself! Unless you can be Batman. Then be Batman.">
            </sps-micro-block>
                `
            }
        }
    },
    warningBlock: {
        label: "Warning Micro Block",
        examples: {
            warningBlock: {
                template: code`
                <sps-micro-block kind="warning" message="Watch yourself, Chester.">
            </sps-micro-block>
                `
            }
        }
    },
    errorBlock: {
        label: "Error Micro Block",
        examples: {
            errorBlock: {
                template: code`
                <sps-micro-block kind="error" message="Uh oh, big problems.">
                </sps-micro-block>
                `
            }
        }
    },

};
